import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { OrderCargoPlaceDetailsForm } from '../../../../../types/cargo';

export const FACT_PACKAGE_QUANTITY_GREATER_THAN_ESTIMATED =
  'factPackageQuantityGreaterThenEstimated';

export function factPackageQuantityValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    if (group instanceof FormGroup) {
      const formGroup =
        group as unknown as FormGroup<OrderCargoPlaceDetailsForm>;
      const packageQuantity =
        formGroup.controls.packageQuantity.getRawValue() ?? 0;
      const factPackageTypesJsonControl =
        formGroup.controls.factPackageTypesJson;
      const factPackageTypesJson = factPackageTypesJsonControl.getRawValue();
      const factPackageQuantity = factPackageTypesJson.reduce(
        (previousValue, currentValue) => {
          return previousValue + (currentValue.packageQuantity ?? 0);
        },
        0,
      );
      if (
        factPackageTypesJson.length &&
        factPackageQuantity !== packageQuantity
      ) {
        const message = `Кол-во коробок (${factPackageQuantity}), должно быть ${packageQuantity}.`;
        factPackageTypesJsonControl.setErrors({
          [FACT_PACKAGE_QUANTITY_GREATER_THAN_ESTIMATED]: message,
        });
      } else {
        factPackageTypesJsonControl.setErrors(null);
      }
      return null;
    }
    return null;
  };
}
